import React from 'react';
import LightGallery from 'lightgallery/react';
import 'lightgallery/scss/lightgallery.scss';
import 'lightgallery/scss/lg-zoom.scss';
import './style.scss';

const Gridimages = ({children}) => {
  return (
    <LightGallery
                // onInit={onInit}
                speed={500}
                plugins={[]}
                elementClassNames='bike-images-item'
            >
                {children}
            </LightGallery>
  )
}

export default Gridimages